import { Injectable } from '@angular/core';
import { Effect, Actions } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs/Observable';
import {
    GET_RECENT_OBSTACLES,
    GetRecentObstacles,
    GetRecentObstaclesSuccess,
    GetRecentObstaclesFailure
} from '../actions/obstacles.actions';
import { ApiService } from '../../services';
import { TOGGLE_FILTER_TYPE, UPDATE_COUNTRY_FILTER, UPDATE_FILTER } from '../actions/filter.actions';
import { State } from '../reducers';

const RECENT_OBSTACLES_LENGTH = 10;
@Injectable()
export class ObstaclesEffects {
    @Effect() getRecentObstacles$ = this.actions$
    .ofType(GET_RECENT_OBSTACLES)
    .startWith(new GetRecentObstacles())
      .switchMap(() => this.api.getObstacles({ count: RECENT_OBSTACLES_LENGTH })
        .mergeMap(recentObstacles => Observable.of(new GetRecentObstaclesSuccess(recentObstacles)))
        .catch(err => Observable.of(new GetRecentObstaclesFailure(err)))
    );

    @Effect() getFilteredRecentObstacles$ = this.actions$
      .ofType(UPDATE_FILTER, UPDATE_COUNTRY_FILTER, TOGGLE_FILTER_TYPE)
      .withLatestFrom(this.store.select(state => state.filter.filter))
      .switchMap(([_, filter]) => this.api.getObstacles({ count: RECENT_OBSTACLES_LENGTH, filter })
        .mergeMap(recentObstacles => Observable.of(new GetRecentObstaclesSuccess(recentObstacles)))
        .catch(err => Observable.of(new GetRecentObstaclesFailure(err)))
    );

    constructor(
      private actions$: Actions,
      private api: ApiService,
      private store: Store<State>
    ) {
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/core/store/effects/obstacles.effects.ts